import type { SliceDef } from '../shared';
import { CARD_POOL, STARTER_DECK, STARTER_OWNED } from '../content/cards/catalog';
import type { Duel } from './rules';
import type { Race, Terrain } from './rules/race';
export interface CardsSave { v: 1; owned: string[]; deck: string[]; ink: number; played: number; wins: number; match: Duel | null; pack: number; race: Race | null; raceCount: number; raceWins: number; snails: Terrain[]; [k: string]: unknown }
export function freshCards(): CardsSave { return { v: 1, owned: [...STARTER_OWNED], deck: [...STARTER_DECK], ink: 0, played: 0, wins: 0, match: null, pack: 0, race: null, raceCount: 0, raceWins: 0, snails: ['moss'] }; }
export function readCards(raw: { v: number } & Record<string, unknown>): CardsSave {
  const defaults = freshCards();
  if (!Array.isArray(raw.owned)) return defaults;
  return { ...defaults, ...raw } as CardsSave;
}
export const cardsSlice: SliceDef<CardsSave> = {
  key: 'cards', version: 1, create: freshCards, migrations: {},
  validate: x => {
    if (!x || typeof x !== 'object' || (x as { v?: unknown }).v !== 1) return ['cards: invalid version'];
    const raw = x as Partial<CardsSave>;
    if (raw.owned !== undefined && (!Array.isArray(raw.owned) || raw.owned.some(id => !CARD_POOL.some(c => c.id === id)))) return ['cards: invalid collection'];
    return [];
  },
};
